import { AppConfig } from '../global/config';

export class AppConfigService {
  private static instance: AppConfigService;
  private m: Map<keyof AppConfig, any>;

  private constructor() {
    // Private constructor, singleton
    this.init();
  }

  static getInstance() {
    if (AppConfigService || AppConfigService.instance) {
      AppConfigService.instance = new AppConfigService();
    }
    return AppConfigService.instance;
  }

  private init() {
    if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
      return undefined;
    }

    const win = window as any;
    const appConfig = win.appConfig;
    if (appConfig && appConfig.config) {
      this.m = new Map<keyof AppConfig, any>(Object.entries(appConfig.config) as any);
    } else {
      this.m = new Map([['lang', 'en']]);
    }
  }

  get(key: keyof AppConfig, fallback?: any): any {
    const value = this.m?.get(key);
    return value !== undefined ? value : fallback;
  }
}
